import script from "./AppOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AppOverview.vue?vue&type=script&setup=true&lang=js"

import "./AppOverview.vue?vue&type=style&index=0&id=05738444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05738444"]])

export default __exports__